import React, { useState, useEffect } from "react";
import { Modal, Button } from 'react-bootstrap';
import { Checkbox, Input } from '../../../Layout/Forms/Form'
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';


const ModalCampaignNotificationSegment = ({ show, handleModalhide, form, handleChangeForm, handlerSegment }) => {
    const [isLoading, setIsLoading] = useState(false);

    const theme = createTheme({
        palette: {
            primary: {
                main: "#6366f1", // Nightspot brand indigo
            },
            secondary: {
                main: '#8b5cf6',
            },
            mode: 'dark',
        },
        components: {
            MuiSlider: {
                styleOverrides: {
                    root: {
                        color: '#6366f1',
                    },
                    thumb: {
                        boxShadow: '0 0 10px rgba(99, 102, 241, 0.5)',
                        '&:hover, &.Mui-focusVisible': {
                            boxShadow: '0 0 15px rgba(99, 102, 241, 0.8)',
                        },
                    },
                    markLabel: {
                        color: 'rgba(255, 255, 255, 0.5)',
                        fontSize: '0.75rem',
                    },
                    valueLabel: {
                        backgroundColor: '#1e293b',
                    }
                }
            }
        }
    });

    const marksAges = [
        { value: 16, label: '16' },
        { value: 25, label: '25' },
        { value: 35, label: '35' },
        { value: 45, label: '45' },
        { value: 55, label: '55' },
        { value: 60, label: '60+' },
    ];

    return (
        <>
            <Modal
                show={show}
                onHide={handleModalhide}
                size="lg"
                centered
                contentClassName="campaign-card border-0"
                style={{ backgroundColor: 'transparent' }}
            >
                <Modal.Header closeButton className="border-0 pb-0" style={{ background: '#0f172a', border: 'none' }}>
                    <Modal.Title className="campaigns-section-title fs-3 mb-0">🎯 Segmentação de Público</Modal.Title>
                </Modal.Header>

                <Modal.Body className="py-4" style={{ background: '#0f172a', border: 'none' }}>
                    <p className="text-muted mb-4 px-2">Define quem deve receber esta campanha para maximizar os resultados.</p>

                    <div >
                        {/* Seção 1: Identificação */}
                        <div className="instruction-box p-4 rounded-4 mb-4">
                            <h6 className="text-white opacity-50 mb-3 text-uppercase small ls-1">Informações Gerais</h6>
                            <div className="row g-3">
                                <div className="col-12 col-md-7">
                                    <Input
                                        label="Nome da campanha"
                                        name="name"
                                        placeholder="Ex: Promoção de Verão"
                                        value={form.name}
                                        onChange={(e) => handleChangeForm(e)}
                                        errors={form.errors}
                                    />
                                </div>
                                <div className="col-12 col-md-5">
                                    <Input
                                        label="Data e hora de Início"
                                        name="release_date"
                                        type="datetime-local"
                                        value={form.release_date}
                                        onChange={(e) => handleChangeForm(e)}
                                        errors={form.errors}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row g-4">
                            {/* Seção 2: Género */}
                            <div className="col-12 col-md-5">
                                <div className="instruction-box p-4 rounded-4 h-100">
                                    <h6 className="text-white opacity-50 mb-3 text-uppercase small ls-1">Género</h6>
                                    <div className="d-flex flex-column gap-3 mt-3">
                                        <Checkbox
                                            label="Feminino"
                                            name="genero"
                                            value={form.genero}
                                            valueCK="Feminino"
                                            checkBoxChange={(e) => handleChangeForm(e, true)}
                                            errors={form.errors}
                                        />
                                        <Checkbox
                                            label="Masculino"
                                            name="genero"
                                            value={form.genero}
                                            valueCK="Masculino"
                                            checkBoxChange={(e) => handleChangeForm(e, true)}
                                            errors={form.errors}
                                        />
                                        <Checkbox
                                            label="Outro"
                                            name="genero"
                                            value={form.genero}
                                            valueCK="Outro"
                                            checkBoxChange={(e) => handleChangeForm(e, true)}
                                            errors={form.errors}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Seção 3: Idades */}
                            <div className="col-12 col-md-7">
                                <div className="instruction-box p-4 rounded-4 h-100">
                                    <h6 className="text-white opacity-50 mb-5 text-uppercase small ls-1">Intervalo de Idades</h6>
                                    <div className="px-3">
                                        <ThemeProvider theme={theme}>
                                            <Slider
                                                getAriaLabel={() => 'Idade'}
                                                value={form.ageRange}
                                                name='ageRange'
                                                onChange={handleChangeForm}
                                                min={16}
                                                max={60}
                                                valueLabelDisplay="on"
                                                marks={marksAges}
                                            />
                                        </ThemeProvider>
                                    </div>
                                    <p className="text-muted small mt-4 mb-0">
                                        <i className="fa-solid fa-circle-info me-2 text-primary"></i>
                                        A campanha será enviada apenas para utilizadores nesta faixa etária.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Seção 4: Volume de Envio */}
                        <div className="instruction-box p-4 rounded-4 mt-4">
                            <div className="d-flex justify-content-between align-items-center mb-5">
                                <h6 className="text-white opacity-50 mb-0 text-uppercase small ls-1">Volume de Envio</h6>
                                <span className="badge bg-primary bg-opacity-10 text-primary border border-primary border-opacity-25 px-3 py-2">
                                    Disponíveis: {form.limits.total}
                                </span>
                            </div>
                            <div className="px-3">
                                <ThemeProvider theme={theme}>
                                    <Slider
                                        getAriaLabel={() => 'Nº Notificações'}
                                        value={form.numNotificacoes ? form.numNotificacoes : form.limits.total}
                                        name='numNotificacoes'
                                        onChange={handleChangeForm}
                                        min={0}
                                        step={10}
                                        max={form.limits.total}
                                        valueLabelDisplay="on"
                                    />
                                </ThemeProvider>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="border-0 pt-0" style={{ background: '#0f172a', border: 'none' }}>
                    <button
                        onClick={handleModalhide}
                        className="btn-action btn-campaign-secondary px-4 rounded-pill border-0 w-auto py-2 me-2"
                    >
                        <i className="fa-solid fa-arrow-left me-2"></i>
                        Anterior
                    </button>
                    <button
                        onClick={() => handlerSegment()}
                        className="btn-action btn-campaign-primary px-4 rounded-pill border-0 w-auto py-2"
                    >
                        Seguinte
                        <i className="fa-solid fa-arrow-right ms-2"></i>
                    </button>
                </Modal.Footer>
            </Modal>


        </>
    )
}


export default ModalCampaignNotificationSegment